import { SortType } from 'modules/types/PagingParams';
import { Empty } from '../empty';
import { StyledPagination, StyledTable, TableScrollWrapper } from './styled';
import { TableBody } from './tableBody';
import { TableColumn } from './TableColumn';
import { TableHead } from './tableHead';
import { Filter } from '../../billsPage/redux/slice';

export interface TableProps {
  columns: TableColumn[];
  rows: React.ReactNode[];
  pageable?: boolean;
  showPaginationHelp?: boolean;
  maxPages?: number;
  totalBills?: number;
  tableFilters?: Filter[];
  checkboxFilters?: Filter[];
  currentPage?: number;
  emptyMessageText?: string;
  columnsMaxWidth?: string;
  onPageChange?: (pageNumber: number) => void;
  onRowCountChange?: (rowCount: number) => void;
  onSortChange?: (
    column: string,
    newSort: SortType,
    newColumnsState?: TableColumn[],
  ) => void;
  fetchColumnCheckbox?: (column: TableColumn) => void;
  showFilterForColumn?: (accessor: string, filterType: string) => boolean;
  showSorting?: (accessor: string) => boolean;
}

export const Table: React.FC<TableProps> = ({
  columns,
  rows,
  pageable,
  showPaginationHelp,
  maxPages,
  totalBills,
  tableFilters,
  checkboxFilters,
  currentPage,
  emptyMessageText,
  columnsMaxWidth,
  onPageChange,
  onRowCountChange,
  onSortChange,
  fetchColumnCheckbox,
  showFilterForColumn,
  showSorting,
  ...props
}) =>
  rows.length === 0 ? (
    <Empty description={emptyMessageText} className="empty" />
  ) : (
    <TableScrollWrapper {...props}>
      <StyledTable>
        <TableHead
          columns={columns}
          tableFilters={tableFilters}
          columnsMaxWidth={columnsMaxWidth}
          onSort={onSortChange}
          checkboxFilters={checkboxFilters}
          fetchColumnCheckbox={fetchColumnCheckbox}
          showFilterForColumn={showFilterForColumn}
          showSorting={showSorting}
        />
        <TableBody columns={columns} rows={rows} />
      </StyledTable>
      {pageable && (
        <StyledPagination
          maxPages={maxPages}
          totalBills={totalBills}
          currentPage={currentPage}
          onPageChange={onPageChange}
          onRowCountChange={onRowCountChange}
          showPaginationHelp={showPaginationHelp}
        />
      )}
    </TableScrollWrapper>
  );
